// Strings locales del módulo M8 · Ajustes (docs/08 Ola B). Shell de /settings + tabs.
export const settingsI18n = {
  title: "Ajustes",
  description: "Configuración de la instancia: branding, seguridad, tokens, sharding y claves.",
  tabs: {
    branding: "Branding",
    security: "Seguridad",
    tokens: "Tokens",
    sharding: "Sharding",
    keys: "Claves de firma",
    apiAccess: "API y acceso",
    webhooks: "Webhooks",
  },
  webhooks: {
    title: "Webhooks",
    description:
      "Entrega eventos a un endpoint con firma HMAC. Se deshabilita solo tras 50 fallos consecutivos.",
    url: "URL del endpoint",
    urlPlaceholder: "https://app.example/hooks/rema",
    events: "Eventos",
    create: "Crear webhook",
    secretNotice: "Guarda este secret de firma; no se vuelve a mostrar:",
    columns: { url: "URL", events: "Eventos", status: "Estado", failures: "Fallos" },
    statuses: { active: "Activo", disabled: "Deshabilitado" },
    test: "Probar",
    delete: "Eliminar",
    empty: "Aún no hay webhooks.",
    testOk: "Entrega correcta",
    testFail: "La entrega falló",
  },
  apiAccess: {
    title: "API keys de app (pk_…)",
    description: "Claves públicas para atribución y orígenes CORS por app. No son secretos.",
    name: "Nombre",
    namePlaceholder: "Nombre de la app",
    origins: "Orígenes permitidos (separados por comas)",
    create: "Crear API key",
    columns: { name: "Nombre", key: "Key", origins: "Orígenes", status: "Estado" },
    statuses: { active: "Activa", revoked: "Revocada" },
    revoke: "Revocar",
    empty: "Aún no hay API keys de app.",
  },
  common: {
    save: "Guardar cambios",
    saved: "Cambios guardados",
    saveError: "No se pudieron guardar los cambios.",
    loadError: "No se pudo cargar la configuración.",
  },
  branding: {
    title: "Branding white-label",
    productName: "Nombre del producto",
    color: "Color primario (hex)",
    colorInvalid: "Usa un hex de 6 dígitos, p. ej. #0F6CBD.",
    themeMode: "Tema por defecto",
    themeModes: { light: "Claro", dark: "Oscuro", system: "Según el sistema" },
    previewTitle: "Vista previa",
    previewLight: "Claro",
    previewDark: "Oscuro",
  },
  security: {
    title: "Política de seguridad",
    minLength: "Longitud mínima de contraseña",
    maxLength: "Longitud máxima de contraseña",
    maxAttempts: "Intentos antes de bloquear",
    baseLock: "Bloqueo base (segundos)",
    maxLock: "Bloqueo máximo (segundos)",
  },
  tokens: {
    title: "Tiempos de vida de tokens (segundos)",
    access: "Access token",
    refresh: "Refresh token",
    m2m: "Token M2M",
    mfa: "Reto MFA",
    reset: "Enlace de reset",
    invite: "Invitación",
  },
  sharding: {
    title: "Estrategia de sharding",
    strategy: "Estrategia",
    strategies: {
      "consistent-hash": "Consistent hash",
      "least-loaded": "Menos cargado",
      manual: "Manual",
    },
    autoReassign: "Reasignar automáticamente si el nodo está caído",
  },
  keys: {
    title: "Claves de firma (ES256)",
    description:
      "La rotación es en dos fases: primero se prepara una clave nueva (next) y, tras el solapamiento, se promueve a activa.",
    columns: { kid: "KID", status: "Estado", created: "Creada" },
    statuses: { active: "Activa", next: "Siguiente", retired: "Retirada" },
    rotate: "Rotar clave",
    rotatePrepared: "Clave siguiente preparada",
    rotatePromoted: "Clave promovida a activa",
    empty: "No hay claves de firma.",
  },
} as const
